import {
  Button,
  Input,
  Label,
  Modal,
  ReactSelect,
  TextArea,
  Typography,
  InputDateTime,
} from "@anchor/react-components/dist/lib/components";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import ButtonGenerator from "../ButtonFactory/ButtonGenerator";
import { RiEdit2Line } from "react-icons/ri";
import { MdDeleteForever } from "react-icons/md";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth/authConfig";
import axios from "axios";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core";
import { postmortemApiEndpoint } from "../../config";
import { convertTimeToGMTTime } from "../../Utils/convertTimeToGMTTime";
import { ACTION_CATEGORIES, HORIZONTAL_VERTICAL_FIX_OPTIONS } from "../../constants/actionCategories";
import { getActionCategory } from "../../Utils/actionCategorizer";
import { MacDataServices } from "../../services/macDataServices";
import { useFetchWithRetry } from "../../Utils/fetchWithRetry";
import Select from "react-select";

// Helper function to get category labels from values
const getCategoryLabels = (categoryValues) => {
  if (!categoryValues || !Array.isArray(categoryValues)) return "";

  const allOptions = ACTION_CATEGORIES.flatMap(cat => cat.options);
  const labels = categoryValues
    .map(val => {
      const option = allOptions.find(opt => opt.value === val);
      return option ? option.label : val;
    })
    .filter(Boolean);

  return labels.join(", ");
};



function PTaskModal({
  pTasks,
  handleModal,
  modalOpen,
  onSave,
  currentpTasks,
  setCurrentpTasks,
}) {
  const [task, setTasks] = useState({
    ptaskid: "",
    type: "",
    eta: "",
    owners: "",
    assignee: "",
    assignment_group: "",
    status: "",
    description: "",
    status: ""
  });
  const [platformPortFolio, setPlatformPortFolio] = useState([]); //
  const [selectedPlatformPortFolio, setSelectedPlatformPortFolio] = useState({
    id: "",
    label: "",
    value: "",
  });
  const [selectedHorizontalVerticalFix, setSelectedHorizontalVerticalFix] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState({ id: "", label: "", value: "" });
  const [selectedProduct, setSelectedProduct] = useState({ id: "", label: "", value: "" });
  const [loadingPlatforms, setLoadingPlatforms] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  // actionCategory will be auto-assigned; no manual selection required
  
  const { fetchPortfolioData, fetchPlatformData, fetchProductData } = MacDataServices();
  const { fetchWithRetry } = useFetchWithRetry();
  const { instance, accounts } = useMsal();
  const [validating, setValidating] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [invalidMessage, setInvalidMessage] = useState("");

  const divRef = useRef(null);

  const validateTicket = () => {
    let taskAlreadyExists = currentpTasks.find(
      (ticket) => ticket.ptaskid[0] === task.ptaskid
    );

    if (taskAlreadyExists) {
      setInvalid(true);
      setInvalidMessage("Ptask already exists");
      return;
    } else {
      setValidating(true);
      setInvalid(false);
      setInvalidMessage("");
      (async () => {
        try {
          const apiEndpoint = postmortemApiEndpoint;
          const url = `${apiEndpoint}/problem-task/${task.ptaskid}`;
          const response = await fetchWithRetry(url, 'PTASK_VALIDATION', 3, 1000);
          if (response) {
            setValidating(false);
            const tasks = {
              ptaskid: task.ptaskid,
              owners: response[0].assigned_to.displayValue,
              description: response[0].short_description,
              assignee: response[0].assignment_group.displayValue,
              assignment_group: response[0].assignment_group.displayValue,
              status: response[0].state
            };
            if (response?.[0]?.due_date) {
              const dateObject = convertTimeToGMTTime(response[0].due_date);
              tasks["eta"] = dateObject;
            }
            setTasks({
              ...tasks,
              actionCategory: [getActionCategory({ description: response[0].short_description || '', incidentTitle: '' })],
            });
          } else {
            console.log("Unknown error");
          }
        } catch (error) {
          setValidating(false);
          setInvalid(true);
          setInvalidMessage("Error in validation PTask ID");
          console.error("Error validating PTask:", error);
        }
      })();
    }
  };

  const handleChange = (target) => {
    const { value, name } = target;

    setTasks((task) => ({
      ...task,
      [name]: value,
    }));
  };

  const deletePTask = (ptaskid) => {
    let currentTasks = [...currentpTasks];
    currentTasks = currentTasks.filter(
      (ticket) => ticket.ptaskid[0] !== ptaskid
    );
    setCurrentpTasks(() => [...currentTasks]);
  };

  const editPtask = (ptaskid) => {
    deletePTask(ptaskid);

    const ptaskIndex = currentpTasks.findIndex(
      (ptask) => ptask.ptaskid[0] === ptaskid
    );

    if (ptaskIndex !== -1) {
      // Create a copy of the object
      const updatedPtask = { ...currentpTasks[ptaskIndex] };

      updatedPtask["owners"] = updatedPtask.owners?.join(",");

      updatedPtask["ptaskid"] = updatedPtask.ptaskid[0];


      // updatedPtask["state"] = updatedPtask.state;

      // console.log("DATE ", new Date(updatedPtask.eta))

      if (updatedPtask?.eta) {
        updatedPtask["eta"] = convertTimeToGMTTime(updatedPtask.eta);
      } else {
        updatedPtask["eta"] = null;
      }

      // updatedPtask["eta"] = convertTimeToGMTTime(updatedPtask.eta);

      setTasks(updatedPtask);
      
      // Find portfolio by name to get its ID
      const portfolio = platformPortFolio.find(p => p.value === updatedPtask.platformPortfolio);
      if (portfolio) {
        setSelectedPlatformPortFolio({
          id: portfolio.id,
          label: portfolio.label,
          value: portfolio.value,
        });
      }
      
      setSelectedHorizontalVerticalFix(updatedPtask.horizontalVerticalFix || null);
      
      // Restore platform and product selections
      if (updatedPtask.ptaskPlatform) {
        setSelectedPlatform({ id: updatedPtask.ptaskPlatform, label: updatedPtask.ptaskPlatform, value: updatedPtask.ptaskPlatform });
      }
      if (updatedPtask.ptaskProduct) {
        setSelectedProduct({ id: updatedPtask.ptaskProduct, label: updatedPtask.ptaskProduct, value: updatedPtask.ptaskProduct });
      }

      // actionCategory is auto-assigned; nothing to restore here
    }

    // const ptask = currentpTasks.find((ptask) => ptask.ptaskid[0] === ptaskid);
  };

  const addPTasks = () => {
    const currentData = { ...task };

    if (currentData.eta) {
      const dateObject = new Date(currentData.eta);

      const day = dateObject.getDate();
      const month = dateObject.getMonth() + 1; // Months are zero-indexed
      const year = dateObject.getFullYear();
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const seconds = dateObject.getSeconds();
      const padZero = (num) => (num < 10 ? "0" + num : num);
      currentData["eta"] = `${padZero(day)}-${padZero(month)}-${year} ${padZero(
        hours
      )}:${padZero(minutes)}:${padZero(seconds)}`;
    } else {
      currentData["eta"] = null;
    }
    currentData["owners"] = currentData.owners.split(",");
    currentData["ptaskid"] = [currentData.ptaskid];
    currentData["link"] = "";
    currentData["platformPortfolio"] = selectedPlatformPortFolio.id;
    currentData["horizontalVerticalFix"] = selectedHorizontalVerticalFix || null;
    currentData["ptaskPlatform"] = selectedPlatform?.value || null;
    currentData["ptaskProduct"] = selectedProduct?.value || null;
    // Auto-assign action category
    currentData["actionCategory"] = [getActionCategory({ description: currentData.description || '', incidentTitle: '' })];

    // currentData["status"] = currentData.status
    // currentData["status"] = currentData.status



    // currentData["eta"] =
    setCurrentpTasks((prev) => {
      const updatedPTasks = [...prev, currentData];
      return updatedPTasks;
    });
    setSelectedPlatformPortFolio({ id: "", label: "", value: "" });
    setSelectedPlatform({ id: "", label: "", value: "" });
    setSelectedProduct({ id: "", label: "", value: "" });
    setSelectedHorizontalVerticalFix(null);
    setTasks({
      ptaskid: "",
      type: "",
      eta: "",
      owners: "",
      assignee: "",
      assignment_group: "",
      status: "",
      description: "",
    });
  };

  useEffect(() => {
    // The modal stays mounted while closed, so without this guard the fetch
    // runs for every render of the page behind it, not just when it opens.
    if (!modalOpen) return;

    const apiEndpoint = postmortemApiEndpoint;
    (async () => {
      try {
        const response = await fetchPortfolioData(apiEndpoint);
        if (response) {
          setPlatformPortFolio(
            response.map((portfolio) => ({
              id: portfolio.portfolioId,
              label: portfolio.portfolioName,
              value: portfolio.portfolioName,
            }))
          );
        } else {
          console.log("Unknown error");
        }
      } catch (e) {
        console.error("Error fetching platform portfolio:", e);
      }
    })();
    // fetchWithRetry is deliberately not a dependency: useFetchWithRetry()
    // returns a new function every render, so listing it re-ran this effect on
    // every render, and the setPlatformPortFolio above re-rendered - a loop
    // that sent ~26k requests from one tab. JiraModal's equivalent effect has
    // always depended on [modalOpen] alone.
  }, [modalOpen]);

  // Fetch platforms when portfolio is selected
  useEffect(() => {
    if (selectedPlatformPortFolio?.id) {
      const fetchPlatforms = async () => {
        setLoadingPlatforms(true);
        try {
          const apiEndpoint = postmortemApiEndpoint;
          const platformsData = await fetchPlatformData(apiEndpoint, selectedPlatformPortFolio.id);
          setPlatforms(platformsData.map(platform => ({
            id: platform.platformId,
            label: platform.platformName,
            value: platform.platformName
          })));
        } catch (error) {
          console.error("Error fetching platforms:", error);
          setPlatforms([]);
        } finally {
          setLoadingPlatforms(false);
        }
      };
      fetchPlatforms();
    } else {
      setPlatforms([]);
      setSelectedPlatform({ id: "", label: "", value: "" });
    }
  }, [selectedPlatformPortFolio]);

  // Fetch products when platform is selected
  useEffect(() => {
    if (selectedPlatform?.id) {
      const fetchProducts = async () => {
        setLoadingProducts(true);
        try {
          const apiEndpoint = postmortemApiEndpoint;
          const productsData = await fetchProductData(apiEndpoint, selectedPlatform.id);
          setProducts(productsData.map(product => ({
            id: product.id,
            label: product.label,
            value: product.value
          })));
        } catch (error) {
          console.error("Error fetching products:", error);
          setProducts([]);
        } finally {
          setLoadingProducts(false);
        }
      };
      fetchProducts();
    } else {
      setProducts([]);
      setSelectedProduct({ id: "", label: "", value: "" });
    }
  }, [selectedPlatform]);




  return (



    <div>
      <Modal
        ref={divRef}
        // className="jira-modal"
        width="1600"
        height="630"
        // max-height="1200"
        backdropcloseactiondisabled={true}
        actions={{
          primaryAction: (
            <Button label="OK" onClick={onSave} appearance="alt" />
          ),
          // secondaryAction: (
          //   <Button label="Back" onClick={handleModal} variant="outlined" />
          // ),
        }}
        heading=<Typography
          variant="h2"
          fontStyle="bold"
          style={{ fontSize: "30px", textAlign: "center" }}
        >
          PTasks
        </Typography>
        onClose={handleModal}
        showCloseIcon={false}
        open={modalOpen}
      >
        <div>
          <Row>
            <Col>
              <Row className="gx-3 gy-3">
                <Col xl={6} xxl={6} className="align-items-center">
                  <Input
                    onChange={(e) => handleChange(e.target)}
                    value={task.ptaskid}
                    label="PTaskId"
                    name="ptaskid"
                    loading={validating}
                    error={invalid}
                    errorMessage={invalidMessage}
                  />
                  <McButton
                    style={{
                      padding: "5px",
                      fontSize: "10px",
                    }}
                    click={validateTicket}
                    className="ptask-add-tour-step"
                  >
                    validate
                  </McButton>
                </Col>
                {/* <Col>
                  <Input
                    onChange={(e) => handleChange(e.target)}
                    value={task.type}
                    label="Type"
                    name="type"
                  />
                </Col> */}

                <Col xl={6} xxl={6}>
                  <InputDateTime
                    dateFormat="dd/MM/yyyy HH:mm"
                    id="dateTimeInput"
                    label="Due Date"
                    onChange={(event) => handleChange(event)}
                    value={task.eta}
                    name="eta"
                    style={{ width: "100%" }}
                    disabled={true}
                    maxDate={new Date()}
                    minDate={new Date("2022-01-01")}
                  ></InputDateTime>
                  {/* <Input
                    type="date"
                    onChange={(e) => handleChange(e.target)}
                    value={task.eta}
                    label="Due Date"
                    name="eta"
                  /> */}
                </Col>

                <Col xl={6} xxl={6} style={{ marginBottom: "10px" }}>
                  <Input
                    onChange={(e) => handleChange(e.target)}
                    value={
                      typeof task.owners === "string"
                        ? task.owners
                        : task.owners.join(",")
                    }
                    label="Owners"
                    name="owners"
                    hint="Enter a list of owners with comma seperated values"
                    placeholder=""
                    disabled={true}
                  />
                </Col>

                <Col xl={6} xxl={6}>
                  <Input
                    onChange={(e) => handleChange(e.target)}
                    value={task.assignment_group}
                    label="Assignment group"
                    name="assignment_group"
                    disabled={true}
                  />
                </Col>

                {/* <Col xl={3} xxl={4}>
                  <Input
                    onChange={(e) => handleChange(e.target)}
                    value={task.status}
                    label="Status"
                    name="status"
                  />
                </Col> */}
              </Row>
              <Row style={{ marginBottom: "20px" }}>

                <Col xl={6} xxl={6}>
                  <Input
                    onChange={(e) => handleChange(e.target)}
                    value={task.status}
                    label="State"
                    name="assignee"
                    disabled={true}
                  />
                </Col>
                <Col xl={6} xxl={6}>
                  <ReactSelect
                    // style={{background:"none"}}
                    // disabled={incidentChangeRef.length === 0}
                    maxMenuHeight={100}
                    className="react-select"
                    closeMenuOnSelect
                    customNoOptionsMessage={<p>Not a valid option</p>}
                    error=""
                    errorMessage=""
                    fit="medium"
                    id="selectAction"
                    isSearchable
                    label="Portfolio"
                    name="platformPortfolio"
                    onChange={(e) => setSelectedPlatformPortFolio(e)}
                    onInputChange={function noRefCheck() { }}
                    onMenuClose={function noRefCheck() { }}
                    onMenuOpen={function noRefCheck() { }}
                    onOptionUpdate={function noRefCheck() { }}
                    options={platformPortFolio}
                    orientation="vertical"
                    // placeholder={incidentChangeRef.length === 0 ? "Please enter the INC/CHG Number first" : "Choose Action Script"}
                    required
                    suggestType="static"
                    // variant
                    // isLoading={}
                    // tooltipDescription="H"
                    value={selectedPlatformPortFolio}
                    variant="default"
                    width={100}
                  />
                </Col>
                <Col xl={6} xxl={6}>
                  <ReactSelect
                    maxMenuHeight={100}
                    className="react-select"
                    closeMenuOnSelect
                    customNoOptionsMessage={<p>Not a valid option</p>}
                    error=""
                    errorMessage=""
                    fit="medium"
                    id="selectPlatform"
                    isSearchable
                    label="Platform"
                    name="ptaskPlatform"
                    onChange={(e) => setSelectedPlatform(e || { id: "", label: "", value: "" })}
                    onInputChange={function noRefCheck() { }}
                    onMenuClose={function noRefCheck() { }}
                    onMenuOpen={function noRefCheck() { }}
                    onOptionUpdate={function noRefCheck() { }}
                    options={platforms}
                    orientation="vertical"
                    suggestType="static"
                    value={selectedPlatform}
                    variant="default"
                    width={100}
                    isClearable
                    isLoading={loadingPlatforms}
                    isDisabled={!selectedPlatformPortFolio?.id}
                  />
                </Col>
              </Row>

              <Row style={{ marginBottom: "20px" }}>
                <Col xl={6} xxl={6}>
                  <ReactSelect
                    maxMenuHeight={100}
                    className="react-select"
                    closeMenuOnSelect
                    customNoOptionsMessage={<p>Not a valid option</p>}
                    error=""
                    errorMessage=""
                    fit="medium"
                    id="selectProduct"
                    isSearchable
                    label="Product"
                    name="ptaskProduct"
                    onChange={(e) => setSelectedProduct(e || { id: "", label: "", value: "" })}
                    onInputChange={function noRefCheck() { }}
                    onMenuClose={function noRefCheck() { }}
                    onMenuOpen={function noRefCheck() { }}
                    onOptionUpdate={function noRefCheck() { }}
                    options={products}
                    orientation="vertical"
                    suggestType="static"
                    value={selectedProduct}
                    variant="default"
                    width={100}
                    isClearable
                    isLoading={loadingProducts}
                    isDisabled={!selectedPlatform?.id}
                  />
                </Col>
                <Col xl={6} xxl={6}>
                  <ReactSelect
                    maxMenuHeight={100}
                    className="react-select"
                    closeMenuOnSelect
                    customNoOptionsMessage={<p>Not a valid option</p>}
                    error=""
                    errorMessage=""
                    fit="medium"
                    id="selectHorizontalVerticalFix"
                    isSearchable
                    label="Horizontal/Vertical Fix"
                    name="horizontalVerticalFix"
                    onChange={(e) => setSelectedHorizontalVerticalFix(e?.value || null)}
                    onInputChange={function noRefCheck() { }}
                    onMenuClose={function noRefCheck() { }}
                    onMenuOpen={function noRefCheck() { }}
                    onOptionUpdate={function noRefCheck() { }}
                    options={HORIZONTAL_VERTICAL_FIX_OPTIONS}
                    orientation="vertical"
                    suggestType="static"
                    value={HORIZONTAL_VERTICAL_FIX_OPTIONS.find(opt => opt.value === selectedHorizontalVerticalFix)}
                    variant="default"
                    width={100}
                    isClearable
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Label id="" label="Description" />
                  <TextArea
                    fit="medium"
                    id="text-area"
                    name="description"
                    // label="Description"
                    onChange={(e) => handleChange(e.target)}
                    placeholder="Describe your  PTask here"
                    required
                    rows={2}
                    value={task.description}
                    disabled={true}
                    spellCheck={true}
                    lang="en"
                  />
                </Col>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <ButtonGenerator
                    appearance="default"
                    id="primary"
                    justifyItems="center"
                    label="Save Task"
                    name="primary"
                    onClick={() => addPTasks()}
                    title="Add"
                    variant="filledAlt"
                    disabled={
                      !task.ptaskid ||
                      !selectedPlatformPortFolio.value
                    }
                  // linkTo=""
                  // style={{ marginLeft: "10px" }}
                  />
                </div>
              </Row>
            </Col>
            <Col
              style={{
                maxHeight: "400px",
                overflowY: "scroll",
              }}
            >
              {currentpTasks && currentpTasks.length > 0 ? (
                <div style={{ padding: "0 20px" }}>
                  <Table
                    style={{ height: "minContent" }}
                    size="sm"
                    striped
                    bordered
                    hover
                  >
                    <thead>
                      <tr>
                        {/* <th>Link</th> */}
                        <th>Action ID</th>
                        <th
                          style={{
                            width: "12rem",
                          }}
                        >
                          Summary
                        </th>
                        {/* <th>Type</th> */}
                        {/* <th>Owners</th> */}
                        <th>Assigned to</th>
                        {/* <th>Assignee</th> */}
                        <th>Assignment group</th>
                        <th>Portfolio</th>
                        <th>Platform</th>
                        <th>Product</th>
                        <th>Fix Type</th>
                        <th>Status</th>
                        <th>Due Date</th>
                        {/* <th>Status</th> */}
                        <th>Edit/ Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentpTasks.map(
                        (ticket, index) => (
                          (
                            <tr key={ticket.ptaskid[0]}>
                              <td>{ticket.ptaskid[0]}</td>
                              <td
                                style={{
                                  width: "12rem",
                                  maxWidth: "12rem",
                                }}
                              >
                                {ticket.description}
                              </td>
                              {/* <td>{ticket.type}</td> */}
                              {typeof ticket.owners === "string" ? (
                                <td>{ticket.owners}</td>
                              ) : (
                                <td>{ticket.owners.join(",")}</td>
                              )}
                              <td>{ticket.assignment_group}</td>

                              <td style={{ width: "10rem", maxWidth: "10rem" }}>
                                {ticket.platformPortfolio
                                  ? ticket.platformPortfolio
                                  : ""}
                              </td>
                              <td>{ticket.ptaskPlatform || "-"}</td>
                              <td>{ticket.ptaskProduct || "-"}</td>
                              <td>{ticket.horizontalVerticalFix || "-"}</td>
                              <td>{ticket.status}</td>


                              <td>{ticket.eta}</td>
                              {/* <td>{ticket.status}</td> */}
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "",
                                  }}
                                >
                                  <div
                                    style={{
                                      marginRight: "20px",
                                      paddingLeft: "20px",
                                    }}
                                  >
                                    <RiEdit2Line
                                      onClick={() =>
                                        editPtask(ticket.ptaskid[0])
                                      }
                                      // onClick={() => editJiraTicket(ticket.link)}
                                      className="editIcons"
                                      style={{}}
                                    />
                                  </div>

                                  <div>
                                    <MdDeleteForever
                                      onClick={() =>
                                        deletePTask(ticket.ptaskid[0])
                                      }
                                      className="editIcons"
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )
                      )}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div
                  className=""
                  style={{
                    disply: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "50px",
                  }}
                >
                  <Typography
                    variant="h4"
                    style={{ textAlign: "center", color: "grey" }}
                  >
                    No Tasks Added
                  </Typography>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Modal>{" "}
    </div>
  );
}

export default PTaskModal;
